const { h } = require('preact');
const UserAuth = require('./UserAuth');

function UserRegister() {
  return <UserAuth tab="register" />;
}

module.exports = UserRegister;
